export default __webpack_public_path__ + "static/media/ss-pika.1142db41.ttf";